/**
 * Generated bundle index. Do not edit.
 */
export { MatSidenavModule, throwMatDuplicatedDrawerError, MatDrawerToggleResult, MatDrawerContent, MatDrawer, MatDrawerContainer, MatSidenavContent, MatSidenav, MatSidenavContainer } from './public-api';
//# sourceMappingURL=index.js.map